/* eslint-disable */
import { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FloatingActionButton } from '@progress/kendo-react-buttons';
import PopUpButton, { INTERNAL_BUTTON, INTERNAL_ITEMS } from '../../components/button';
import FormRow from '../../components/formRow';
import Table from '../../components/table';
import PopUpConfirm from '../../components/popUps/popUpConfirm';
import PopUpError from '../../components/popUps/popUpError';
import { successNotification, warningNotification } from '../../components/notification';
import { getAll, exclude } from '../../services/taxClass';
import LoadScreen from '../load';
import TaxClassRegistration from './taxClassRegistration';
import { toMoney } from '../../utils/formatter';
import './styles.css';

const TaxClasses = () => {
  const history = useHistory();
  const [taxClasses, setTaxClasses] = useState([]);
  const [selectedIds, setSelectedsIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popUpConfirmVisibility, setPopUpConfirmVisibility] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [viewMode, setViewMode] = useState('list');
  const [selectedTaxClassId, setSelectedTaxClassId] = useState(null);
  const handleEdit = (id) => {
    setSelectedTaxClassId(id);
    setViewMode('edit');
  };

  const handleCreate = () => {
    setSelectedTaxClassId(null);
    setViewMode('edit');
  };

  const handleCancelEdit = () => {
    setViewMode('list');
    setSelectedTaxClassId(null);
  };

  const handleSaveSuccess = async () => {
    await loadTaxClasses();
    setViewMode('list');
    setSelectedTaxClassId(null);
  };

  const renderBaseAliq = (baseField, aliqField) => ({ dataItem }) => {
    const base = dataItem[baseField] != null ? toMoney(dataItem[baseField], true) : '-';
    const aliq = dataItem[aliqField] != null ? toMoney(dataItem[aliqField], true) : '-';
    return (
      <td className="right-column" onClick={() => handleEdit(dataItem.Id)} style={{ cursor: 'pointer' }}>
        {`${base} / ${aliq}`}
      </td>
    );
  };

  const columns = [
    {
      field: 'Nome',
      title: 'Nome',
      width: 260,
      columnMenuCheckbox: true
    },
    {
      field: 'ISS',
      title: 'ISS (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoISS', 'AliquotaISS'),
      sortable: false
    },
    {
      field: 'PIS',
      title: 'PIS (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoPIS', 'AliquotaPIS'),
    },
    {
      field: 'COFINS',
      title: 'COFINS (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoCOFINS', 'AliquotaCOFINS'),
    },
    {
      field: 'CSLL',
      title: 'CSLL (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoCSLL', 'AliquotaCSLL'),
    },
    {
      field: 'IRRF',
      title: 'IRRF (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoIRRF', 'AliquotaIRRF'),
    },
    {
      field: 'INSS',
      title: 'INSS (Base/Aliqu.)',
      cell: renderBaseAliq('BaseCalculoINSS', 'AliquotaINSS'),
    }
  ];

  const loadTaxClasses = async () => {
    setLoading(true);
    const { data } = await getAll();
    setTaxClasses(data);
    setLoading(false);
  };

  const excludeTaxClasses = async () => {
    const excludeTaxClassesRequests = selectedIds.map((taxClassSelected) =>
      exclude(taxClassSelected)
    );

    const excludeTaxClassesResponses = await Promise.all(excludeTaxClassesRequests);

    const isAllRequestsRight = excludeTaxClassesResponses.reduce(
      (acc, currentResponse) => acc && currentResponse.status === 200,
      true
    );

    if (isAllRequestsRight) successNotification('Classe(s) de impostos excluída(s) com sucesso!');
    else {
      const erro = ['Houve um erro ao tentar excluir um ou mais classes de impostos:'];
      excludeTaxClassesResponses.forEach((element) => {
        const { data } = element;
        erro.push(data.MensagemUsuario);
      });
      setPopUpErrorMessage(erro);
      setPopUpError(true);
    }

    setSelectedsIds([]);
    await loadTaxClasses();
  };

  useEffect(() => {
    loadTaxClasses();
  }, []);

  if (viewMode === 'edit') {
    return <TaxClassRegistration id={selectedTaxClassId} onCancel={handleCancelEdit} onSave={handleSaveSuccess} />;
  }

  return loading ? (
    <LoadScreen />
  ) : (
    <>
      <div id="taxClass-list">
        <h1>Classe de Impostos</h1>

        <FormRow justifyEnd withoutMarginTop space10>
          <div className="config-components-popup-button">
            <FloatingActionButton icon={INTERNAL_BUTTON.BUTTON_ADD} onClick={handleCreate} />
          </div>
          <PopUpButton
            internalButton={INTERNAL_BUTTON.BUTTON_THREEPOINTS}
            internalItems={[
              {
                id: INTERNAL_ITEMS.EXCLUIR,
                onClick: () => {
                  if (selectedIds.length > 0) setPopUpConfirmVisibility(true);
                  else warningNotification('Nenhuma classe de impostos selecionada');
                },
                text: 'Excluir Classes de Impostos'
              }
            ]}
          />
        </FormRow>
        <Table
          data={taxClasses}
          columns={columns}
          dataItemKey="Id"
          haveCheckbox
          haveOnClick
          setItemKeysSelected={setSelectedsIds}
          style={{ minHeight: 500, marginTop: 20, height: '100%' }}
          onClickInRow={({ Id }) => handleEdit(Id)}
          sortable={true}
        />
      </div>
      <PopUpConfirm
        onConfirm={excludeTaxClasses}
        visible={popUpConfirmVisibility}
        setVisible={setPopUpConfirmVisibility}
        title="Confirmação"
        message="Você tem certeza que deseja excluir a(s) classe(s) de impostos selecionada(s)?"
      />
      <PopUpError
        visible={popUpError}
        setVisible={setPopUpError}
        title="Erro ao excluir um serviço"
        message={popUpErrorMessage}
      />
    </>
  );
};

export default TaxClasses;
